import { Box, Dropdown, HStack, Spacer, VStack } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage } from 'react-intl';

import { useAppDispatch } from '@/store/hooks.ts';
import { removeTile } from '@/store/tiles/slice.ts';

export function InvalidWorkspaceTile({ tileId }: { tileId: string }) {
  const dispatch = useAppDispatch();
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const closeTile = () => {
    sgwtWebAnalytics?.trackEvent('Tiles', 'Close invalid tile', tileId);
    dispatch(removeTile(tileId));
  };

  return (
    <VStack className="bg-lvl1 py-2" fullWidth fullHeight>
      <HStack className="mb-2" flex="min">
        <Spacer />
        <Dropdown color={'flat-primary' as 'primary'} direction="auto" size="md" data-e2e="tile-menu">
          <Dropdown.Toggle className="btn-icon" data-e2e="menu-button">
            <i className="icon">more_vert</i>  
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={closeTile} data-e2e="close-tile-menu">
              <FormattedMessage id="tile.invalidWorkspace.close" />
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </HStack>
      <VStack className="bg-lvl1 ps-2 pe-2" fullWidth flex="expand">
        <Box flex="min">
          <h3>
            <span className="icon">error_outline</span>   &nbsp;
            <FormattedMessage id="tile.invalidWorkspace.title" />
          </h3>
        </Box>
        <Box className="mt-2" flex="expand">
          <FormattedMessage id="tile.invalidWorkspace.description" />
        </Box>
      </VStack>
    </VStack>
  );
}